import type { NotificationCategory } from '../../services/notification';

export const PAGE_SIZE = 10;

export const INNER_TAB_ID_CATEGORY_MAP: Record<number, NotificationCategory> = {
  1: 'All',
  2: 'Cases',
  3: 'Agreements',
  4: 'Assets',
};

export const CATEGORY_INNER_TAB_ID: Record<NotificationCategory, number> = {
  All: 1,
  Cases: 2,
  Agreements: 3,
  Assets: 4,
};
